import React from 'react';

import {
  Slide,
} from '@mui/material';

import type { TransitionProps } from '@mui/material/transitions';

// eslint-disable-next-line prefer-arrow-callback
const DialogTransition = React.forwardRef(function Transition(
  props: TransitionProps & {
    /** 子要素 */
    children: React.ReactElement;
  },
  ref: React.Ref<unknown>,
) {
  // eslint-disable-next-line react/jsx-props-no-spreading
  return <Slide direction="up" ref={ref} {...props} />;
});

export default DialogTransition;
